import { render, staticRenderFns } from "./VsPrism.vue?vue&type=template&id=5593d9e5&"
import script from "./VsPrism.vue?vue&type=script&lang=js&"
export * from "./VsPrism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports